import { Skeleton as PSkeleton } from 'primereact/skeleton';
import classNames from 'classnames';
import { ISkeleton } from './Skeleton.types';

export const Skeleton: React.FC<ISkeleton> = (props) => {
  const { width = '100%', height = '100%', shape, className } = props;
  return (
    <div className={classNames(className)}>
      <PSkeleton width={width} height={height} shape={shape} />
    </div>
  );
};
